import DataGrid, { Column, Scrolling, } from "devextreme-react/cjs/data-grid";
import { useEffect, useMemo, useState, type FC } from "react";
import { Card, Col, Row, Button, Modal } from "react-bootstrap";
import AddCustomer from "./CustomerModal";
import OldGoldModal from "./OldGoldModal";
import PaymentModal from "./PaymentModal";
import CustomOrderModal from "./CustomOrderModal";
import SalesPersonModal from "./SalesPersonModal";
import { AddProductFormModel } from "../models/custom-order-form-model";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare, faTrash } from "@fortawesome/free-solid-svg-icons";
import { PaymentEntry } from "../models/payment-form-model";
import { OldGoldEntry } from "../models/old-gold-form-model";
import { CiDiscount1 } from "react-icons/ci";
import { FaRust } from "react-icons/fa";
import { DiscountModal1 } from "./DiscountModal1";
import { CreateEstimate, FreezeGoldRate, GetDiscountAndGoldRateDetailsForCustomOrderApi, GetMaterialTypeList, GetOldGoldRateByKaratIdApi } from "../../services";
import notistack from "modules/core/notistack";
import { HttpStatus } from "modules/core";
import { LuBadgeIndianRupee } from "react-icons/lu";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "slices/app/store/store";
import { SetCunsumerId } from "slices/cunsumerOffer/reducer";
import { RenderImageCell } from "./renderImageCell";
import { useNavigate } from "react-router-dom";
import { handleKeyDown } from "Common/modal/ModalTriggerButton";
import Loader from "Common/Loader";
import { HasPermission } from "Layout/Permissions/permissionsCache";
interface EstimatePaymentReceiptProps { }

const EstimatePaymentReceipt: FC<EstimatePaymentReceiptProps> = () => {
    const [showCustomerModal, setShowCustomerModal] = useState(false);
    const [showOldGoldModal, setShowOldGoldModal] = useState(false);
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [showCustomOrderModal, setShowCustomOrderModal] = useState(false);
    const [showSalesPersonModal, setShowSalesPersonModal] = useState(false);
    const [editingProduct, setEditingProduct] = useState<AddProductFormModel | null>(null);
    const [openConsumerOfferDetailesDialog, setOpenConsumerOfferDetailesDialog] = useState(false);
    const [billingAddressId, setBillingAddressId] = useState<any>()
    const [discountAndGoldRateDetailsForCustomOrderData, setDiscountAndGoldRateDetailsForCustomOrderData] = useState([]);
    const navigate = useNavigate()
    const [isDiscountFreeze, setIsDiscountFreeze] = useState(false)
    const renderHeaderCell = (headerInfo: any) => {
        return <div className="text-nowrap">{headerInfo.column.caption}</div>;
    };

    const [customerData, setCustomerData] = useState<object | any>()

    const handleCustomerClickModal = () => {
        setShowCustomerModal(true);
    }

    const handleCustomerClick = (data: any) => {

        setCustomerData(data)
        // sessionStorage.setItem("customerData", JSON.stringify(data));
    };

    const handleCustomOrderClick = () => {
        setEditingProduct(null);
        setShowCustomOrderModal(true)
    };


    const handleSalesPersonClick = () => {
        setShowSalesPersonModal(true);
    };

    const [salesPersonId, setSalesPersonId] = useState<string | any>()

    const handleSalesPersonSelect = (salesPId: string) => {
        setSalesPersonId(salesPId)
    };


    const closeModal = () => {
        setShowCustomerModal(false)
    }

    const [customOrderProducts, setCustomOrderProducts] = useState<AddProductFormModel[]>([]);

    const handleProductListChange = (updatedProduct: AddProductFormModel, isEdit: boolean = false) => {
        if (isEdit) {
            setCustomOrderProducts(prev =>
                prev.map(product =>
                    product.id === updatedProduct.id ? updatedProduct : product
                )
            );
        } else {
            setCustomOrderProducts(prev => [...prev, updatedProduct]);
        }
    };

    const handleDeleteCustomeOrder = (id: any) => {
        dispatch(SetCunsumerId(null));
        setIsDiscountFreeze(false)
        setCustomOrderProducts(prev =>
            prev.filter(product => String(product.id) !== String(id))
        );
    }

    const handleEditCustomeOrder = (data: AddProductFormModel) => {
        setEditingProduct(data);
    }

    const [paymentData, setPaymentData] = useState<PaymentEntry[]>([]);
    const [editingPaymentData, setEditingPaymentData] = useState<PaymentEntry[]>([]);

    const openAddPaymentModal = () => {
        setEditingPaymentData([]);
        setShowPaymentModal(true);
    };


    const handlePaymentData = (data: PaymentEntry[]) => {
        setPaymentData(data);
    };
    const openEditPaymentModal = () => {
        setEditingPaymentData(paymentData);
        setShowPaymentModal(true);
    };

    const [editingOldGoldnDataData, setEditingOldGoldnDataData] = useState<OldGoldEntry[]>([]);
    const [currentOldGoldData, setCurrentOldGoldData] = useState<OldGoldEntry[]>([]);

    const handelOldGoldnData = (data: OldGoldEntry[]) => {
        setCurrentOldGoldData(data);

    };

    const openEditModal = () => {
        setEditingOldGoldnDataData(currentOldGoldData);
        setShowOldGoldModal(true);
    };

    const openNewModal = () => {
        setEditingOldGoldnDataData([]);
        setShowOldGoldModal(true);
    };

    const material = customOrderProducts?.[0]?.materialType
    const kt = customOrderProducts?.[0]?.odKt || customOrderProducts?.[0]?.kt
    const [materialTypes, setMaterialTypes] = useState<{ value: string; text: string }[]>([]);
    const matchedValues =
        customOrderProducts?.flatMap((product) => {
            return materialTypes
                ?.filter(
                    (m) =>
                        m.text == product.materialType
                )
                ?.map((m) => m.value) ?? [];
        }) ?? [];
    const matchedMaterial = materialTypes?.find((m) => m.text === material as string);
    const matchedValue = matchedMaterial?.value;

    const combinedData = {
        customerData,
        customOrderProducts,
        paymentData,
        currentOldGoldData,
        salesPersonId
    };
    const [goldFreezPercentage, setGoldFreezPercentage] = useState<any>()
    const [freezeAmount, setFreezeAmount] = useState<number>(0);
    const cunsumerOfferId = useSelector((state: RootState) => state?.CunsumerOfferId?.cunsumerOfferId)
    const filteredDiscountData: any = discountAndGoldRateDetailsForCustomOrderData?.filter((item: any) => item.id == cunsumerOfferId?.id)

    const discountValue = filteredDiscountData[0]?.discountValue ?? 0.00;
    const isPercentage = filteredDiscountData[0]?.isPercentage || false;
    const [selectedBilling, setSelectedBilling] = useState<string | number | null>(null)
    const [isGoldRateFreeze, setIsGoldRateFreeze] = useState(false);
    const [karatListFor24, setKaratListFor24] = useState<any[]>([])
    const [goldRate, setGoldRate] = useState<number>(0);

    const valueOf24KT = useMemo(() => {
        return Number(
            karatListFor24.find(item => item?.text?.toLocaleLowerCase() === "24KT".toLocaleLowerCase())?.value ?? 0
        );
    }, [karatListFor24]);

    const GetOldGoldRateByKaratId = async (karatId: number) => {
        try {
            if (!karatId) return;
            const response = await GetOldGoldRateByKaratIdApi(karatId);
            setGoldRate(Number(response?.metalRate ?? 0));
        } catch (err) {
            console.error("Error fetching gold rate:", err);
            notistack.error("Failed to fetch gold rate");
            setGoldRate(0);
        }
    };

    useEffect(() => {
        if (valueOf24KT > 0) {
            GetOldGoldRateByKaratId(valueOf24KT);
        }
    }, [valueOf24KT]);

    function transformDataToPayload(combinedData: any) {
        const {
            customerData,
            salesPersonId,
            paymentData,
            currentOldGoldData,
            customOrderProducts,
        } = combinedData;

        return {
            CustomerId: customerData?.id ?? 0,
            BillingAddressId: selectedBilling,
            SalesPersonId: parseInt(salesPersonId ?? "0"),
            DiscountFreez: parseInt(discountValue ?? 0),
            ConsumerOfferId: isDiscountFreeze ? (cunsumerOfferId?.id ?? null) : null,
            GoldRateFreez: isGoldRateFreeze ? goldRate : 0,

            PaymentDetailsModelList: (paymentData ?? []).map((p: any) => ({
                PaymentType: p?.type ?? "",
                Amount: parseFloat(p?.amount ?? "0"),
                RefNo: p?.referenceNumber ?? ""
            })),

            PurchaseOrderDetailsModel: {
                TotalAmount: (currentOldGoldData ?? []).reduce(
                    (sum: number, item: any) => sum + (item?.totalAmt ?? 0),
                    0
                ),
                CustomerId: customerData?.id ?? 0,
                SalesPersonId: parseInt(salesPersonId ?? "0"),
                PurchaseOrderItemsDetails: (currentOldGoldData ?? []).map((item: any) => ({
                    MetalId: item?.material === "Gold" ? 1 : 0,
                    KaratId: parseInt(item?.odKt ?? "0"),
                    Rate: item?.rate ?? 0,
                    Purity: parseFloat(item?.purity ?? "0"),
                    NetWeight: parseFloat(item?.netWt ?? "0"),
                    EquivalentWeight: item?.equivalentWt ?? 0,
                    PurchaseAmount: item?.totalAmt ?? 0,
                    Note: item?.note ?? ""
                }))
            },

            CustomOrderModelItemList: (customOrderProducts ?? []).map((item: any, index: any) => ({
                MaterialTypeId: Number(matchedValues[index]),
                StyleNo: parseInt(item?.styleNo ?? "0"),
                CategoryId: parseInt(item?.category ?? "0"),
                CollectionId: parseInt(item?.collectionName ?? "0"),
                KaratId: parseInt(item?.odKt ?? item.kt),
                FromNetWeight: item?.fromNetWt ?? 0,
                ToNetWeight: item?.toNetWt ?? 0,
                GoldRate: item?.goldRate ?? 0,
                EstimateAmount: item?.estimateAmt ?? 0,
                ImageLink: item?.image ?? "",
                ColorCode: item?.colorCode ?? "",
                KaratCode: item?.odKt ?? "",
                DiamondClarityId: Number(item?.diamondClarity ?? 0),
                DiamondWeight: item?.diaWt ?? 0,
                DiamontQty: item?.diaQty ?? 0,
                DiamontAmount: item?.diaAmt ?? 0,
                ColorStoneAmount: item?.colorStoneAmt ?? 0,
                Tag: item?.tag ?? "",
                IsMrp: item?.srpMrp === "MRP",
                CGst: item?.cgst ?? 0,
                IGst: item?.igst ?? 0,
                Mrp: item?.mrp ?? 0,
                SubMrp: item?.subMrp ?? 0,
                Size: item?.size ?? 0
            }))
        };
    }

    const finalPayload = transformDataToPayload(combinedData);

    const [isSubmitting, setIsSubmitting] = useState(false)
    const MakeEstimatePamentReceipt = async () => {
        try {
            if (!customerData?.id) {
                return notistack.warning("Please select a customer before proceeding.");
            }
            if (!Boolean(customOrderProducts?.length > 0)) {
                return notistack.warning("No product found, please check!");
            }
            if (!selectedBilling) {
                notistack.warning("Please select a customer address");
                return;
            }
            if (!salesPersonId || parseInt(salesPersonId) === 0) {
                return notistack.warning("Please select a salesperson before proceeding.");
            }

            if (freezeAmount >= 0) {
                if (freezeAmount <= (calculations?.totalPaidAmt + calculations?.oldGoldAmt)) {
                    setIsSubmitting(true)
                    const response = await CreateEstimate(finalPayload)
                    if (response.status === HttpStatus.Success) {
                        notistack.notifyFromApi(response)
                        setCustomerData(null)
                        setCustomOrderProducts([])
                        setPaymentData([])
                        setCurrentOldGoldData([])
                        dispatch(SetCunsumerId(null));
                        setSalesPersonId(0)
                        setIsSubmitting(false)
                        navigate('/custom-order-list', { state: { openFirstRecord: true } });
                    }
                    else {
                        setIsSubmitting(false)
                        notistack.notifyFromApi(response)
                        return
                    }
                }
                else {
                    setIsSubmitting(false)
                    notistack.warning('Frozen gold rate/offer. Advance payment required.')
                    return
                }
            }
            setIsSubmitting(false)
        } catch (error: any) {
            notistack.error(error.message)
        }
        finally {
            setIsSubmitting(false);
        }
    }

    const calculations = useMemo(() => {
        const estimateAmt = customOrderProducts.reduce((sum, product) => {
            const subMrp = Number(product?.subMrp);
            const estimate = Number(product?.estimateAmt);
            const mrp = Number(product?.mrp);

            const value =
                subMrp && subMrp > 0 ? subMrp :
                    estimate && estimate > 0 ? estimate :
                        mrp && mrp > 0 ? mrp : 0;

            return sum + value;
        }, 0);

        let validDiscount = 0.00;

        const disEstimateAmt = estimateAmt;

        const oldGoldAmt = currentOldGoldData.reduce(
            (sum, gold) => sum + (Number(gold?.totalAmt) || 0),
            0
        );

        const totalPaidAmt = paymentData.reduce(
            (sum, payment) => sum + (Number(payment?.amount) || 0),
            0
        );

        const totalEffectivePaid = totalPaidAmt + oldGoldAmt;
        const netAmt = disEstimateAmt;

        const dueAmt = Math.max(0, netAmt - totalEffectivePaid);

        const excessPayment = Math.max(0, totalPaidAmt - netAmt);

        return {
            disEstimateAmt,
            estimateAmt,
            discountValue: validDiscount,
            oldGoldAmt,
            totalPaidAmt,
            totalEffectivePaid,
            netAmt,
            dueAmt,
            excessPayment,
        };
    }, [customOrderProducts, currentOldGoldData, paymentData, discountValue]);


    useEffect(() => {
        const parsedPercentage =
            typeof goldFreezPercentage === "string"
                ? parseFloat(goldFreezPercentage.replace('%', ''))
                : goldFreezPercentage;

        if (parsedPercentage) {
            if (calculations.estimateAmt > 0) {
                const freeze = (calculations.estimateAmt * parsedPercentage) / 100;
                setFreezeAmount(freeze);
            } else {
                notistack.error("Estimate amount is zero. Cannot calculate freeze amount.");
                setFreezeAmount(0);
            }
        }
    }, [goldFreezPercentage, calculations.estimateAmt]);

    useEffect(() => {
        MaterialTypeListData()
    }, [customOrderProducts])

    const MaterialTypeListData = async () => {
        try {
            const response = await GetMaterialTypeList()
            // if (response.status === HttpStatus.Success) {
            setMaterialTypes(response)
            // }
        } catch (error: any) {
            notistack.notifyFromApi(error.message)
            console.log(error.message)
            setMaterialTypes([])
        }
    }

    const openPriceDialog = () => {
        GetDiscountAndGoldRateDetailsForCustomOrder(matchedValue, kt)
        setOpenConsumerOfferDetailesDialog(true)
    }

    const GetDiscountAndGoldRateDetailsForCustomOrder = async (materialId: any, ktId: any) => {
        try {
            const response = await GetDiscountAndGoldRateDetailsForCustomOrderApi(materialId, ktId);
            if (response.status === HttpStatus.Success) {
                setDiscountAndGoldRateDetailsForCustomOrderData(response?.data?.consumerOfferDetails)
            }
            else {
                notistack.notifyFromApi(response)
            }
        } catch (err: any) {
            notistack.notifyFromApi(err.message)
            console.error("Error fetching gold rate:", err);
        }
    }

    const dispatch = useDispatch()
    const [showCancelConfirmModal, setShowCancelConfirmModal] = useState(false)
    const handleCancel = () => {
        sessionStorage.removeItem("customerData");
        setCustomerData(null)
        setCustomOrderProducts([])
        setPaymentData([])
        setCurrentOldGoldData([])
        setSalesPersonId(0)
        dispatch(SetCunsumerId(null));
        window.location.reload()
    }



    const handleFreezeGoldRate = async () => {
        try {
            if (isGoldRateFreeze) {
                notistack.error('Gold rate is already frozen.');
                return;
            }

            // if (!cunsumerOfferId?.id) {
            //     notistack.error('Please add a consumer offer to proceed.');
            //     return;
            // }

            const response = await FreezeGoldRate();
            if (response.status === HttpStatus.Success) {
                setIsGoldRateFreeze(true);
                const { discountFreez, goldRateFreez } = response.data;
                const greaterValue = Math.max(
                    Number(discountFreez ?? 0),
                    Number(goldRateFreez ?? 0)
                );
                setGoldFreezPercentage(greaterValue);
                notistack.notifyFromApi(response);
            } else {
                notistack.warning(
                    response?.data.message || response?.data
                );
            }
        } catch (error: any) {
            notistack.error(error.message);
        }
    };

    const handleFreezeDiscount = () => {
        try {
            if (isDiscountFreeze) {
                notistack.error('Discount is already frozen.');
                return;
            }
            if (!cunsumerOfferId?.id) {
                notistack.warning('Please add a consumer offer to proceed.');
                return;
            }
            setIsDiscountFreeze(true)
            notistack.success('Discount has been frozen successfully');
            return
        } catch (error: any) {
            notistack.error(error.message)
        }
    }

    useEffect(() => {
        const handleBeforeUnload = (e: BeforeUnloadEvent) => {
            if (
                customerData ||
                customOrderProducts.length > 0 ||
                paymentData.length > 0 ||
                currentOldGoldData.length > 0
            ) {
                e.preventDefault();
                e.returnValue = "You have unsaved changes. Are you sure you want to leave?";
                return e.returnValue;
            }
        };

        window.addEventListener("beforeunload", handleBeforeUnload);

        return () => {
            window.removeEventListener("beforeunload", handleBeforeUnload);
        };
    }, [customerData, customOrderProducts, paymentData, currentOldGoldData]);


    useEffect(() => {
        const navEntries = performance.getEntriesByType('navigation') as PerformanceNavigationTiming[];
        if (navEntries.length > 0 && navEntries[0].type === 'reload') {

        }
    }, []);

    return (
        <>
            {isSubmitting && <Loader />}
            <div className="page-content">
                <div className="container-fluid">
                    <Card>
                        <Card.Header className="d-flex gap-5 align-items-center">
                            <h5 className="m-0">Make to Order</h5>

                            {customOrderProducts.length > 0 && (
                                <div className="d-flex align-items-center gap-2">
                                    {discountValue > 0 && <CiDiscount1 size={30} title="Freeze Discount" role="button" onClick={handleFreezeDiscount} />}
                                    {Number(calculations.disEstimateAmt.toFixed(2)) > 0 && (
                                        <LuBadgeIndianRupee
                                            onClick={handleFreezeGoldRate}
                                            size={25}
                                            title="Freeze Gold Rate"
                                            role="button"
                                        />
                                    )}
                                    {/* Show goldFreezPercentage if available */}
                                    {goldFreezPercentage ? (
                                        <span className="text-danger">
                                            ({goldFreezPercentage}%)
                                        </span>
                                    ) : null}
                                    {/* Show freezeAmount if available */}
                                    {freezeAmount ? (
                                        <span className="text-danger">
                                            Advance amount is: ₹{freezeAmount.toFixed(2)}
                                        </span>
                                    ) : null}
                                </div>
                            )}
                        </Card.Header>
                        {HasPermission("EstimatePayment.Write") &&
                            <Card.Body className="pt-0">
                                <Row>
                                    <Col lg={9}>
                                        <div className="m-2 d-flex gap-2 flex-wrap">
                                            <Button
                                                variant={`outline-primary ${customerData?.customerAddressList?.length > 0 && Number(selectedBilling) && 'bg-success text-white border-white'}`}
                                                size="sm"
                                                onKeyDown={handleKeyDown}
                                                onClick={handleCustomerClickModal}
                                            >
                                                <i className="bx bx-user me-1"></i>
                                                Customer
                                            </Button>
                                            <Button
                                                variant={`outline-primary ${customOrderProducts.length > 0 && 'bg-success text-white border-white'}`}
                                                size="sm"
                                                onKeyDown={handleKeyDown}
                                                onClick={handleCustomOrderClick}
                                            >
                                                <i className="bx bx-package me-1"></i>
                                                Make to Order
                                            </Button>
                                            <Button
                                                variant={`outline-primary ${salesPersonId && 'bg-success text-white border-white'}`}
                                                size="sm"
                                                onClick={handleSalesPersonClick}
                                            >
                                                <i className="bx bx-user-check me-1"></i>
                                                Sales Person
                                            </Button>

                                            <Button
                                                variant={`outline-primary ${paymentData.length > 0 && 'bg-success text-white border-white'}`}
                                                onKeyDown={handleKeyDown}
                                                size="sm"
                                                onClick={paymentData.length > 0 ? openEditPaymentModal : openAddPaymentModal}
                                            >
                                                <i className="bx bx-credit-card me-1"></i>
                                                Payment
                                            </Button>

                                            <Button
                                                variant={`outline-primary ${currentOldGoldData.length > 0 && 'bg-success text-white border-white'}`}

                                                size="sm"
                                                onClick={currentOldGoldData.length > 0 ? openEditModal : openNewModal}

                                            >
                                                <i className="bx bx-crown me-1"></i>
                                                Old Gold
                                            </Button>

                                        </div>

                                        <DataGrid
                                            dataSource={customOrderProducts}
                                            remoteOperations={{ groupPaging: true }}
                                            showRowLines={true}
                                            keyExpr="id"
                                            showBorders={true}
                                            allowColumnReordering={true}
                                            allowColumnResizing={true}
                                            columnAutoWidth={true}
                                            wordWrapEnabled={true}
                                        >
                                            <Column
                                                caption="Action"
                                                cssClass="text-center"
                                                cellRender={({ data }) => (
                                                    <div className="d-flex justify-content-center align-items-center gap-2">
                                                        <button className='btn btn-sm action-btn delete-btn'
                                                            onClick={() =>
                                                                handleDeleteCustomeOrder(data.id)
                                                            }
                                                        >
                                                            <FontAwesomeIcon icon={faTrash} className='ml-2' />
                                                        </button>

                                                        <button
                                                            className='btn btn-sm action-btn edit-btn'
                                                            onClick={() => {
                                                                handleEditCustomeOrder(data);
                                                                setShowCustomOrderModal(true);
                                                            }}
                                                        >
                                                            <FontAwesomeIcon icon={faPenToSquare} className='ml-2' />
                                                        </button>
                                                    </div>
                                                )}
                                            />
                                            <Column
                                                dataField="image"
                                                caption="Image"
                                                width={80}
                                                cellRender={RenderImageCell}
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Scrolling
                                                mode='standard'
                                                useNative={true}
                                                scrollByContent={true}
                                                scrollByThumb={true}
                                            />

                                            <Column
                                                dataField="materialType"
                                                caption="Material Type"
                                                dataType="string"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="styleNoText"
                                                caption="Style No"
                                                dataType="string"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="ktText"
                                                caption="Metal Kt"
                                                dataType="string"
                                                width={150}
                                                headerCellRender={renderHeaderCell}
                                                cellRender={({ data }) => (
                                                    <div
                                                        title={data.ktText} // tooltip on hover
                                                        style={{
                                                            whiteSpace: 'nowrap',
                                                            overflow: 'hidden',
                                                            textOverflow: 'ellipsis',
                                                        }}
                                                    >
                                                        {data.ktText}
                                                    </div>
                                                )}
                                            />
                                            <Column
                                                dataField="categoryText"
                                                caption="Category"
                                                dataType="string"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="fromNetWt"
                                                caption="From Net Wt"
                                                dataType="number"
                                                format="#,##0.000"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="toNetWt"
                                                caption="To Net Wt"
                                                dataType="number"
                                                format="#,##0.000"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="diaWt"
                                                caption="Dia Wt"
                                                dataType="number"
                                                format="#,##0.000"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="diaQty"
                                                caption="Dia Qty"
                                                dataType="number"
                                                format="#,##0.000"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="diaAmt"
                                                caption="Dia Amt"
                                                dataType="number"
                                                format="#,##0.00"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="colorStoneAmt"
                                                caption="Color Stone Amt"
                                                dataType="number"
                                                format="#,##0.00"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="goldRate"
                                                caption="Gold Price"
                                                dataType="number"
                                                format="#,##0.00"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="size"
                                                caption="Size"
                                                dataType="number"
                                                headerCellRender={renderHeaderCell}
                                            />
                                            <Column
                                                dataField="estimateAmt"
                                                caption="Estimate Amt"
                                                dataType="number"
                                                format="#,##0.00"
                                                headerCellRender={renderHeaderCell}
                                                calculateCellValue={(rowData) => {
                                                    const { subMrp, estimateAmt, mrp } = rowData ?? {};
                                                    return Number(subMrp) > 0
                                                        ? Number(subMrp)
                                                        : Number(estimateAmt) > 0
                                                            ? Number(estimateAmt)
                                                            : Number(mrp) > 0
                                                                ? Number(mrp)
                                                                : 0;
                                                }}
                                            />
                                        </DataGrid>
                                    </Col>

                                    <Col lg={3}>
                                        <div className="payment-calculator">
                                            <div className="summary-tables">
                                                {/* Summary Table */}
                                                {customOrderProducts.length > 0 && (
                                                    <div className="mb-3">
                                                        <table className="table table-bordered table-sm">
                                                            <thead className="table-light">
                                                                <tr>
                                                                    <th colSpan={2} className="text-center">
                                                                        Summary
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>Estimate Amt</td>
                                                                    <td className="text-end">
                                                                        ₹ {calculations.estimateAmt.toFixed(2)}
                                                                    </td>
                                                                </tr>
                                                                <tr>
                                                                    <td>Discount Amt <i
                                                                        className="fa fa-tags"
                                                                        onClick={openPriceDialog}
                                                                        aria-hidden="true"
                                                                        title="View Consumer Offer Details"
                                                                        style={{
                                                                            cursor: 'pointer',
                                                                            transition: 'all 0.2s ease',
                                                                            fontSize: '1.1rem',
                                                                            color: discountAndGoldRateDetailsForCustomOrderData ? '#007bff' : '#6c757d',
                                                                            marginLeft: '8px'
                                                                        }}
                                                                        onMouseOver={(e) => {
                                                                            e.currentTarget.style.color = '#0056b3';
                                                                            e.currentTarget.style.transform = 'scale(1.2)';
                                                                        }}
                                                                        onMouseOut={(e) => {
                                                                            e.currentTarget.style.color = discountAndGoldRateDetailsForCustomOrderData ? '#007bff' : '#6c757d';
                                                                            e.currentTarget.style.transform = 'scale(1)';
                                                                        }}
                                                                    ></i></td>
                                                                    <td className="text-end">
                                                                        {discountValue > 0 && (
                                                                            <>
                                                                                {isPercentage ? (
                                                                                    `${discountValue}%`
                                                                                ) : (
                                                                                    <>
                                                                                        ₹{(Math.floor(Number(discountValue) * 100) / 100).toFixed(2)}
                                                                                    </>
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                                <tr className="table-info">
                                                                    <td><strong>Net Amount</strong></td>
                                                                    <td className="text-end">
                                                                        <strong>₹ {calculations.disEstimateAmt.toFixed(2)}</strong>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                )}

                                                <div className="mb-3">
                                                    <table className="table table-bordered table-sm">
                                                        <thead className="table-light">
                                                            <tr>
                                                                <th colSpan={2} className="text-center">
                                                                    Payment Details
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td >Old Gold Amt</td>
                                                                <td className="text-end">₹ {calculations.oldGoldAmt.toFixed(2)}</td>
                                                            </tr>
                                                            {paymentData.map((payment) => (
                                                                <tr key={payment.id}>
                                                                    <td style={{ color: "green" }}>{payment.type}</td>
                                                                    <td style={{ color: "green" }} className="text-end">₹ {Number(payment.amount).toFixed(2)}</td>
                                                                </tr>
                                                            ))}
                                                            <tr className="table-info">
                                                                <td style={{ color: "green" }}><strong>Total Paid</strong></td>
                                                                <td style={{ color: "green" }} className="text-end">
                                                                    <strong>
                                                                        {(calculations?.totalPaidAmt || calculations?.oldGoldAmt)
                                                                            ? `₹ ${(Number(calculations.totalPaidAmt || 0) + Number(calculations.oldGoldAmt || 0)).toFixed(2)}`
                                                                            : '₹ 0.00'}
                                                                    </strong>

                                                                </td>
                                                            </tr>

                                                            <tr className={calculations.dueAmt > 0 ? "table-warning" : "table-success"}>
                                                                <td><strong>Due Amount</strong></td>
                                                                <td className="text-end">
                                                                    <strong>₹ {calculations?.dueAmt
                                                                        ? (calculations.dueAmt.toFixed(2))
                                                                        : '0.00'}</strong>
                                                                </td>
                                                            </tr>
                                                            {calculations.excessPayment > 0 && (
                                                                <tr className="table-danger">
                                                                    <td style={{ color: "green" }}><strong>Advance Payment</strong></td>
                                                                    <td style={{ color: "green" }} className="text-end">
                                                                        <strong>₹ {(calculations.excessPayment.toFixed(2))}</strong>
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>

                                                    <div className="mt-3">
                                                        <button
                                                            className="btn submit-btn me-3"
                                                            onClick={MakeEstimatePamentReceipt}
                                                            disabled={isSubmitting}
                                                        >
                                                            Save
                                                        </button>
                                                        <button className="btn add-btn" onClick={() => setShowCancelConfirmModal(true)}>Cancel</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        }
                    </Card>
                </div>
            </div >

            {/* Customer Modal */}
            <AddCustomer
                show={showCustomerModal}
                customerData={customerData}
                handleCustomerClick={handleCustomerClick}
                closeModal={closeModal}
                setBillingAddressId={setBillingAddressId}
                setSelectedBilling={setSelectedBilling}
                selectedBilling={selectedBilling}
            />

            {/* Old Gold Modal */}
            <OldGoldModal
                show={showOldGoldModal}
                onHide={() => setShowOldGoldModal(false)}
                handelOldGoldnData={handelOldGoldnData}
                initialOldGoldnData={editingOldGoldnDataData}
            />

            {/* Payment Modal */}
            <PaymentModal
                show={showPaymentModal}
                onHide={() => setShowPaymentModal(false)}
                handelPaymentData={handlePaymentData}
            />

            {/* Custom Order Modal */}
            <CustomOrderModal
                show={showCustomOrderModal}
                editProduct={editingProduct}
                onHide={() => {
                    setShowCustomOrderModal(false);
                    setEditingProduct(null);
                }}
                onProductListChange={handleProductListChange}
                setKaratListFor24={setKaratListFor24}
            />

            {/* Sales Person Modal */}
            <SalesPersonModal
                show={showSalesPersonModal}
                onHide={() => setShowSalesPersonModal(false)}
                onSelect={handleSalesPersonSelect}
                selectedSalesPersonId={salesPersonId}
            />

            {/* {Consumer Offer Detailed Dialog} */}
            <DiscountModal1
                show={openConsumerOfferDetailesDialog}
                onHide={() => setOpenConsumerOfferDetailesDialog(false)}
                discountAndGoldRateDetailsForCustomOrderData={discountAndGoldRateDetailsForCustomOrderData || []}
            />


            <Modal show={showCancelConfirmModal} onHide={() => setShowCancelConfirmModal(false)} backdrop="static" centered>
                <Modal.Header closeButton>
                    <Modal.Title>Confirm Cancel</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    Are you sure you want to cancel and reset the form? This action cannot be undone.
                </Modal.Body>
                <Modal.Footer>
                    <button className="btn add-btn" onClick={() => setShowCancelConfirmModal(false)}>
                        No, Go Back
                    </button>
                    <button className="btn submit-btn" onClick={() => {
                        handleCancel();
                        setShowCancelConfirmModal(false);
                    }}>
                        Yes, Cancel It
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default EstimatePaymentReceipt;


